import { create } from "zustand";

type State = {
	showStimulusModal?: boolean;
	setShowStimulusModal: (show?: boolean) => void;
};

export const useStimulusStore = create<State>()((set) => ({
	setShowStimulusModal: (show) => set({ showStimulusModal: show }),
}));
